//记得在 src\components\lang\zhLoad.js 里面添加对象
const user= {
  clientName:'ClientName',
  userNo: 'UserNo',
  userName:'Name',
  useStatusDesc: '状态',
  roleName:'Role',
  roleCode: '角色',
  officeTel:'OfficeTel',
  mobileTel:'MobileTel',
  addr:'Address',
  fax:'Fax',
  email:'Email',
  remark:'Remark',
  addUser:'AddUser',
  editUser:'EditUser',
  assignRole:'AssignRole',
  editPwd:'EditPwd',
  resetPwd:'ResetPwd',
  currentPwd:'CurrentPwd',
  newPwd:'InputPwd',
  enterAgain:'EnterAgain',
  userTypeNo: 'User Type',
  brandName: '品牌',
  isQiyeWxLoginStr: '是否绑定微信',
  branCode: '品牌',
  counterNo: '柜台',
  rolerNo: '角色',
  employeeId:'员工ID',
  supplierCode: 'supplierCode',
  supplierName: 'supplierName',
  msg:{
    userNo:'Please input the userNo',
    userName:"Please input the userName",
    userType: 'Please input the userType',
    currentPwd:'Please input the current password',
    newPwd:'Please input the new password',
    enterAgain:'Please enter again the new password',
    inputPwdError:'Different passwords are entered twice. Please re-enter them.',
    setRoleAllocation:'Are you sure you want to keep it? This operation has not checked the role, continue operation will delete the original role!',
    email: 'Please enter your email address'
  }
};
export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/lang/user.en.js